import { FormGroup } from '@angular/forms';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-degree-major-entry',
  templateUrl: './degree-major-entry.component.html',
  styleUrls: ['./degree-major-entry.component.css']
})
export class DegreeMajorEntryComponent implements OnInit {

  form:FormGroup;

  constructor(
    public dialogRef: MatDialogRef<DegreeMajorEntryComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) { }

  ngOnInit() {
  }
  submit(){

  }

}
